
/* injects from baggage-loader */

'use strict';

import AddBankAccountComponent from './add-bank-account.component';
import './add-bank-account.scss';

const AddBankAccountModule = angular.module('add-bank-account-module', []);

AddBankAccountModule
    .component('addBankAccount', new AddBankAccountComponent());

export default AddBankAccountModule;




// WEBPACK FOOTER //
// ./src/app/components/add-bank-account/add-bank-account.module.js